import { render, staticRenderFns } from "./NumberOfEmployees.vue?vue&type=template&id=64fbbf12&scoped=true&"
import script from "./NumberOfEmployees.vue?vue&type=script&lang=ts&"
export * from "./NumberOfEmployees.vue?vue&type=script&lang=ts&"
import style0 from "./NumberOfEmployees.vue?vue&type=style&index=0&id=64fbbf12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fbbf12",
  null
  
)

export default component.exports